var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdcWxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.06 0 0 8.059 0 18c0 9.94 8.06 18 18 18 9.941 0 18-8.06 18-18 0-9.941-8.06-18-18-18z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36c9.975 0 18-8.025 18-18S27.975 0 18 0 0 8.025 0 18s8.025 18 18 18z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.502 14.325c-2.176 5.775.824 12.3 6.675 14.4.225.15.45.45.45.675v1.05c0 .15 0 .225-.076.3-.075.3-.374.45-.675.3a13.492 13.492 0 0 1-8.775-8.775c-2.25-7.125 1.65-14.7 8.775-16.95.075-.075.225-.075.3-.075.3.075.45.3.45.6V6.9c0 .375-.15.6-.45.75-3.075 1.125-5.55 3.525-6.674 6.675zm13.95-8.7c.074-.3.374-.45.674-.3 4.125 1.35 7.425 4.575 8.775 8.85 2.25 7.125-1.65 14.7-8.774 16.95-.075.075-.226.075-.3.075-.3-.075-.45-.3-.45-.6v-1.05c0-.375.15-.6.45-.75 3.074-1.125 5.55-3.525 6.674-6.675 2.175-5.775-.825-12.3-6.675-14.4-.224-.15-.45-.45-.45-.75v-1.05c0-.15 0-.225.075-.3zM18.226 16.95c3.15.375 4.725 1.274 4.725 3.9 0 2.024-1.5 3.6-3.75 3.975v1.8c-.075.375-.3.6-.6.6h-1.125c-.375-.076-.6-.3-.6-.6v-1.8c-2.475-.376-3.675-1.726-3.975-3.6v-.076c0-.3.225-.525.525-.525h1.275c.225 0 .45.15.525.45.225 1.125.9 1.95 2.85 1.95 1.425 0 2.475-.824 2.475-2.024 0-1.2-.675-1.65-2.775-2.025-3.15-.376-4.65-1.35-4.65-3.826 0-1.874 1.425-3.374 3.675-3.674V9.75c.075-.376.3-.6.6-.6h1.125c.375.074.6.3.6.6v1.8a3.747 3.747 0 0 1 3.375 3.074v.075c0 .3-.225.525-.525.525h-1.2a.564.564 0 0 1-.525-.374c-.375-1.125-1.125-1.575-2.475-1.575-1.5 0-2.25.674-2.25 1.724 0 1.05.45 1.65 2.7 1.95z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#000",
    d: "M-4 19.5h43.909V30H-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.717 28.5h-.352v-.682h-.352v-.682h-.352v-.681h-.352v-.682h-.352v-.682h-.352v-.682h-.352v.682h-.352v.682h-.352v.681h-.352v.682h-.352v.682h-.352v.682h-.352V21h1.056v3.75h.352v-.682h.352v-.682h.352v-.681h.352v.681h.352v.682h.352v.682h.352V21h1.056v7.5zM21 28.5h-1.056v-1.023h-.352v-1.023h-.352v-.681h-.352v-.341h-.352v.34h-.352v.683h-.352v1.022h-.352V28.5h-1.056v-1.023h.352v-1.023h.352v-.681h.352v-.682h.352v-.682h-.352v-.682h-.352v-.681h-.352v-1.023h-.352V21h1.056v1.023h.352v1.023h.352v.681h.352v.341h.352v-.34h.352v-.683h.352v-1.022h.352V21H21v1.023h-.352v1.023h-.352v.681h-.352v.682h-.352v.682h.352v.682h.352v.681h.352v1.023H21V28.5zM26.282 27.818h-.352v.341h-.352v.341h-2.464v-.34h-.352v-.342h-.352v-.34h-.352v-.342h-.352v-4.772h.352v-.341h.352v-.341h.352v-.341h.352V21h2.464v.34h.352v.342h.352v.682h-1.056v-.341h-1.76v.34h-.352v.341h-.352v4.091h.352v.341h.352v.341h1.76v-2.045h-.352v.34h-1.056V24.41h2.464v3.41z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcWxg);
export default __webpack_public_path__ + "static/media/USDC-WXG.5b86a2237dfe3e50cb6308b8f03a29ac.svg";
export { ForwardRef as ReactComponent };